// extracted by mini-css-extract-plugin
export default {"button":"MediaSectionContainer-button-f7e5a709f0f7be9fe897de5357746cc7","icon":"MediaSectionContainer-icon-47b8f61fad6315cb0640eff9cefdd864"};